export function getLatestReceiptOwnerIndexes(latestOrder: bigint | undefined, maxReceipts: number): bigint[] {
  if (latestOrder === undefined || maxReceipts <= 0) return []

  return Array.from({ length: maxReceipts }, (_, index) => latestOrder - BigInt(index)).filter(
    (orderIndex) => orderIndex >= 0n,
  )
}
